import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import Wave from '../assets/images/wave.svg';

import Block from './Block';

const BlockWave = styled(Block)`
  background-image: url(${Wave});
  background-repeat: no-repeat;
  background-size: 400px;
  background-position: bottom -60px right;
  padding-bottom: 100px;

  ${breakpoint('smallTablet')`
    background-size: 500px;
    padding-bottom: 120px;
    background-position: bottom -80px right;
  `};

  ${breakpoint('tablet')`
    background-size: 850px;
    padding-bottom: 110px;
    background-position: bottom -130px right;
  `};

  ${breakpoint('laptop')`
    background-size: 950px;
    padding-bottom: 120px;
    background-position: bottom -150px right;
  `};

  ${breakpoint('desktop')`
    background-size: 1200px;
    padding-bottom: 140px;
    background-position: bottom -190px right;
  `};

  ${breakpoint('large')`
    background-size: 1400px;
    padding-bottom: 180px;
    background-position: bottom -220px right;
  `};
`;

export default BlockWave;
